import React from 'react'
import agent from '../agent'
import ContractList from './widgets/ContractList';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import {
    CONTRACT_LIST_PAGE_LOADED,
    CONTRACT_LIST_NEXT_PAGE_LOADED,
    CONTRACT_LIST_SEARCH_LOADED,
    UPDATE_CONTRACT_SEARCHTERM,
    CONTRACT_LIST_PAGE_UNLOADED,
    CHANGE_DATE_STRINGS
} from '../constants/actionTypes'
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';

const mapStateToProps = state => ({
    ...state.contract,
    appName: state.common.appName,
    token: state.common.token,
    date_from: state.common.date_from,
    date_to: state.common.date_to
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload, pageIndex, terms, status, date_from, date_to) => {
        dispatch({ type: CONTRACT_LIST_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, status, date_from, date_to })
    },
    onLoadNextPage: (payload, pageIndex, terms, status, date_from, date_to) => {
        dispatch({ type: CONTRACT_LIST_NEXT_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, status, date_from, date_to })
    },
    onSearch: (payload, pageIndex, terms, status, date_from, date_to) => {
        dispatch({ type: CONTRACT_LIST_SEARCH_LOADED, payload, currentPage: pageIndex, searchTerm: terms, status, date_from, date_to })
    },
    onChangeSearchTerm: value =>
        dispatch({ type: UPDATE_CONTRACT_SEARCHTERM, key: 'searchTerm', value }),
    onChangeDateStrings: (date_from, date_to) =>
        dispatch({ type: CHANGE_DATE_STRINGS, date_from, date_to }),
    onUnload: () =>
        dispatch({ type: CONTRACT_LIST_PAGE_UNLOADED }),
});

class Contracts extends React.Component {
    constructor() {
        super();
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.changeSearchTerm = (ev) => this.props.onChangeSearchTerm(ev.target.value)
        this.handleAllSelected = this.handleChangeStatus.bind(this, 'all')
        this.handleDisplaySelected = this.handleChangeStatus.bind(this, 'display')
        this.handleNotDisplaySelected = this.handleChangeStatus.bind(this, 'notdisplay')

        this.search = () => ev => {
            ev.preventDefault()
            const pageIndex = 1;
            const terms = this.props.searchTerm || ''
            const status = this.props.status || ''
            const date_from = this.props.date_from || ''
            const date_to = this.props.date_to || ''
            const type = 'erc20'
            const payload = agent.Contracts.list(type, pageIndex, terms, status, date_from, date_to)
            this.props.onSearch(payload, pageIndex, terms, status, date_from, date_to)
        }

    }
    componentWillMount() {
        const pageIndex = 1;
        const terms = ''
        const status = ''
        const date_from = ''
        const date_to = ''
        const type = 'erc20'
        const payload = agent.Contracts.list(type, pageIndex, terms, status, date_from, date_to)
        this.props.onLoad(payload, pageIndex, terms, status, date_from, date_to);
    }

    componentWillUnmount() {
        this.props.onUnload();
    }
    handlePageChanged(newPage) {
        const pageIndex = newPage + 1;
        const terms = this.props.searchTerm || ''
        const status = this.props.status || ''
        const date_from = this.props.date_from || ''
        const date_to = this.props.date_to || ''
        const type = 'erc20'
        const payload = agent.Contracts.list(type, pageIndex, terms, status, date_from, date_to)
        this.props.onLoadNextPage(payload, pageIndex, terms, status, date_from, date_to);
    }
    handleChangeStatus(contractStatus) {
        const pageIndex = 1;
        const terms = this.props.searchTerm || ''
        const status = contractStatus || ''
        const date_from = this.props.date_from || ''
        const date_to = this.props.date_to || ''
        const type = 'erc20'
        const payload = agent.Contracts.list(type, pageIndex, terms, status, date_from, date_to)
        this.props.onLoad(payload, pageIndex, terms, status, date_from, date_to);
    }
    handleChangeDateStrings(dates, dateStrings) {
        var unixFrom = dateStrings[0] ? moment(dateStrings[0]).format('X') : ''
        var unixTo = dateStrings[1] ? moment(moment(dateStrings[1]).format('YYYY-MM-DD 23:59:59')).format('X') : ''
        this.props.onChangeDateStrings(unixFrom, unixTo)
    }
    render() {
        const date_from = this.props.date_from ? moment(moment(this.props.date_from * 1000).format('YYYY-MM-DD')) : ''
        const date_to = this.props.date_to ? moment(moment(this.props.date_to * 1000).format('YYYY-MM-DD')) : ''

        return (
            <div class='pane'>
                <Link className="buttonTop" to='/contracts/create'><i className="icon ion-android-add-circle"></i></Link>
                <h1>ERC Tokens</h1>
                <div className="filters">
                    <div className="filterTabs">
                        <Link to='/contracts' className={!this.props.status || this.props.status === 'all' ? "selected" : ""} value='all' onClick={this.handleAllSelected}>All</Link>
                        <Link to='/contracts?status=display' className={this.props.status === 'display' ? "selected" : ""} onClick={this.handleDisplaySelected}>Display</Link>
                        <Link to='/contracts?status=notdisplay' className={this.props.status === 'notdisplay' ? "selected" : ""} onClick={this.handleNotDisplaySelected}>Not Displayed</Link>
                    </div>
                    <div className="filterSearch">
                        <RangePicker
                            ranges={{ 'This Month': [moment().startOf('month'), moment()], Today: [moment(), moment()] }}
                            value={[date_from, date_to]}
                            onChange={this.handleChangeDateStrings.bind(this)}
                        />
                        <input type="text" placeholder="find contract" value={this.props.searchTerm} onChange={this.changeSearchTerm} />
                        <button type="submit" onClick={this.search()}>Find</button>
                    </div>
                </div>
                <ContractList contracts={this.props.contracts} loading={this.props.loading} />
                {
                    this.props.contracts && this.props.contracts.length > 0 ?
                        <Pager
                            total={this.props.totalPage || 0}
                            current={this.props.currentPage - 1}
                            visiblePages={7}
                            titles={{ first: '<<', last: '>>' }}
                            onPageChanged={this.handlePageChanged.bind(this)}
                        />
                        : null
                }
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Contracts);



// WEBPACK FOOTER //
// ./src/components/Contracts.js